"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
var _sliceInstanceProperty2 = require("@babel/runtime-corejs3/core-js-stable/instance/slice");
var _reverseInstanceProperty = require("@babel/runtime-corejs3/core-js-stable/instance/reverse");
var _Promise = require("@babel/runtime-corejs3/core-js-stable/promise");
var _Object$setPrototypeOf = require("@babel/runtime-corejs3/core-js-stable/object/set-prototype-of");
var _typeof = require("@babel/runtime-corejs3/helpers/typeof");
var _forEachInstanceProperty = require("@babel/runtime-corejs3/core-js-stable/instance/for-each");
var _Object$getPrototypeOf = require("@babel/runtime-corejs3/core-js-stable/object/get-prototype-of");
var _Object$create = require("@babel/runtime-corejs3/core-js-stable/object/create");
var _Symbol = require("@babel/runtime-corejs3/core-js-stable/symbol");
var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.FilePreviewPDFTron = void 0;
exports.canBePreviewed = canBePreviewed;
exports.canRenderOnClient = canRenderOnClient;
exports.canRenderOnServer = canRenderOnServer;
exports.download = download;
exports.downloadFile = downloadFile;
exports.downloadFileAs = downloadFileAs;
exports.getFileExtensionFromType = getFileExtensionFromType;
exports.getFilenameWithExtension = getFilenameWithExtension;
exports.getWebViewerLanguage = getWebViewerLanguage;
exports.openPreviewPDFTron = openPreviewPDFTron;
exports.registerFilePreviewPDFTron = void 0;
require("core-js/modules/es.array.iterator.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.typed-array.uint8-array.js");
require("core-js/modules/es.typed-array.copy-within.js");
require("core-js/modules/es.typed-array.every.js");
require("core-js/modules/es.typed-array.fill.js");
require("core-js/modules/es.typed-array.filter.js");
require("core-js/modules/es.typed-array.find.js");
require("core-js/modules/es.typed-array.find-index.js");
require("core-js/modules/es.typed-array.for-each.js");
require("core-js/modules/es.typed-array.includes.js");
require("core-js/modules/es.typed-array.index-of.js");
require("core-js/modules/es.typed-array.iterator.js");
require("core-js/modules/es.typed-array.join.js");
require("core-js/modules/es.typed-array.last-index-of.js");
require("core-js/modules/es.typed-array.map.js");
require("core-js/modules/es.typed-array.reduce.js");
require("core-js/modules/es.typed-array.reduce-right.js");
require("core-js/modules/es.typed-array.reverse.js");
require("core-js/modules/es.typed-array.set.js");
require("core-js/modules/es.typed-array.slice.js");
require("core-js/modules/es.typed-array.some.js");
require("core-js/modules/es.typed-array.sort.js");
require("core-js/modules/es.typed-array.subarray.js");
require("core-js/modules/es.typed-array.to-locale-string.js");
require("core-js/modules/es.typed-array.to-string.js");
require("core-js/modules/es.function.name.js");
require("core-js/modules/es.regexp.to-string.js");
require("core-js/modules/es.promise.js");
var _flags = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/flags"));
var _setTimeout2 = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/set-timeout"));
var _bind = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/bind"));
var _slice = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/slice"));
var _find = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/find"));
var _findIndex = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/find-index"));
var _objectSpread2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectSpread2"));
var _createForOfIteratorHelper2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createForOfIteratorHelper"));
var _filter = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/filter"));
var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/taggedTemplateLiteral"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/inherits"));
var _createSuper2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createSuper"));
var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));
var _includes = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/includes"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/asyncToGenerator"));
var _map2 = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/map"));
var _element = require("@onviobr/element");
var _user = require("@onviobr/services/profile/user");
var _session = require("@onviobr/services/session");
var _webviewer = _interopRequireDefault(require("@pdftron/webviewer"));
var _fileSaver = require("file-saver");
var _bentoFonts = require("../assets/bento-css/bento-fonts");
var _i18n = require("../i18n/i18n");
var _emitEvents = require("../utils/emit-events");
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8;
function _regeneratorRuntime() { "use strict"; _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = _Object$defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof _Symbol ? _Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return _Object$defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = _Object$create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = _Object$getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = _Object$create(IteratorPrototype); function defineIteratorMethods(prototype) { var _context37; _forEachInstanceProperty(_context37 = ["next", "throw", "return"]).call(_context37, function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var methodName = context.method, method = delegate.iterator[methodName]; if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel; var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], _forEachInstanceProperty(tryLocsList).call(tryLocsList, pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return _Object$setPrototypeOf ? _Object$setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = _Object$create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = _Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) keys.push(key); return _reverseInstanceProperty(keys).call(keys), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { var _context38; if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, _forEachInstanceProperty(_context38 = this.tryEntries).call(_context38, resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+_sliceInstanceProperty2(name).call(name, 1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
var PreviewStatus;
(function (PreviewStatus) {
  PreviewStatus["None"] = "none";
  PreviewStatus["Ready"] = "ready";
  PreviewStatus["NotReady"] = "not-ready";
  PreviewStatus["Loading"] = "loading";
  PreviewStatus["Loaded"] = "loaded";
  PreviewStatus["NotLoaded"] = "not-loaded";
})(PreviewStatus || (PreviewStatus = {}));
var PREVIEW_INSTANCE;
var PDFTRON_PUBLIC_LIB = 'pdftron-lib';
var PDF_EXTENSION = 'pdf';
var PDF_MIMETYPE = 'application/pdf';
var filesRenderedOnClient = ['pdf', 'docx', 'xlsx', 'pptx', 'jpg', 'jpeg', 'png'];
var filesRenderedOnServer = ['bmp', 'tiff', 'txt', 'rtf', 'eml', 'doc', 'docm', 'dot', 'dotm', 'ppt', 'xls', 'ppt', 'xlt', 'xlsm', 'xltx', 'xps'];
var fileExtensionMimeTypeMap = new _map2.default();
fileExtensionMimeTypeMap.set('plain', 'txt');
fileExtensionMimeTypeMap.set('msword', 'doc');
fileExtensionMimeTypeMap.set('vnd.openxmlformats-officedocument.wordprocessingml.document', 'docx');
fileExtensionMimeTypeMap.set('vnd.ms-powerpoint', 'ppt');
fileExtensionMimeTypeMap.set('vnd.openxmlformats-officedocument.presentationml.presentation', 'pptx');
fileExtensionMimeTypeMap.set('vnd.ms-excel', 'xls');
fileExtensionMimeTypeMap.set('vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'xlsx');
function getWebViewerLanguage(_x) {
  return _getWebViewerLanguage.apply(this, arguments);
}
function _getWebViewerLanguage() {
  _getWebViewerLanguage = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regeneratorRuntime().mark(function _callee17(language) {
    var currentUser;
    return _regeneratorRuntime().wrap(function _callee17$(_context31) {
      while (1) switch (_context31.prev = _context31.next) {
        case 0:
          if (language) {
            _context31.next = 5;
            break;
          }
          _context31.next = 3;
          return (0, _user.getCurrentUser)();
        case 3:
          currentUser = _context31.sent;
          language = currentUser.language || 'en';
        case 5:
          _context31.t0 = language.toLowerCase();
          _context31.next = _context31.t0 === 'xx-xx' ? 8 : _context31.t0 === 'pt-br' ? 9 : 10;
          break;
        case 8:
          return _context31.abrupt("return", 'en');
        case 9:
          return _context31.abrupt("return", 'pt_br');
        case 10:
          return _context31.abrupt("return", language.substr(0, 2).toLowerCase());
        case 11:
        case "end":
          return _context31.stop();
      }
    }, _callee17);
  }));
  return _getWebViewerLanguage.apply(this, arguments);
}
function getFileExtensionFromType(fileType) {
  fileType = (0, _includes.default)(fileType).call(fileType, '/') ? fileType.split('/').pop().toLowerCase() : fileType.toLowerCase();
  fileType = fileExtensionMimeTypeMap.has(fileType) ? fileExtensionMimeTypeMap.get(fileType) : fileType;
  return (0, _includes.default)(filesRenderedOnClient).call(filesRenderedOnClient, fileType) || (0, _includes.default)(filesRenderedOnServer).call(filesRenderedOnServer, fileType) ? fileType : undefined;
}
function getFilenameWithExtension(filename, fileType) {
  var _context;
  var parts = filename.split('.');
  if (parts.length > 1) {
    return filename;
  }
  var expectedExtension = getFileExtensionFromType(fileType);
  return expectedExtension ? (0, _concat.default)(_context = "".concat(filename, ".")).call(_context, getFileExtensionFromType(fileType)) : filename;
}
function canRenderOnClient(fileType) {
  return (0, _includes.default)(filesRenderedOnClient).call(filesRenderedOnClient, getFileExtensionFromType(fileType) || 'not-supported');
}
function canRenderOnServer(fileType) {
  return (0, _includes.default)(filesRenderedOnServer).call(filesRenderedOnServer, getFileExtensionFromType(fileType) || 'not-supported');
}
function canBePreviewed(fileType) {
  return canRenderOnClient(fileType) || canRenderOnServer(fileType);
}
function download(_x2, _x3, _x4) {
  return _download.apply(this, arguments);
}
function _download() {
  _download = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regeneratorRuntime().mark(function _callee18(ctx, viewerInstance, file) {
    return _regeneratorRuntime().wrap(function _callee18$(_context32) {
      while (1) switch (_context32.prev = _context32.next) {
        case 0:
          if (!(getFileExtensionFromType(file.type) === PDF_EXTENSION)) {
            _context32.next = 3;
            break;
          }
          void viewerInstance.UI.downloadPdf();
          return _context32.abrupt("return", true);
        case 3:
          return _context32.abrupt("return", downloadFile(ctx, file));
        case 4:
        case "end":
          return _context32.stop();
      }
    }, _callee18);
  }));
  return _download.apply(this, arguments);
}
function downloadFileAs(_x5, _x6) {
  return _downloadFileAs.apply(this, arguments);
}
function _downloadFileAs() {
  _downloadFileAs = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regeneratorRuntime().mark(function _callee19(viewer, filename) {
    var data, byteArray, blob;
    return _regeneratorRuntime().wrap(function _callee19$(_context33) {
      while (1) switch (_context33.prev = _context33.next) {
        case 0:
          _context33.next = 2;
          return viewer.Core.documentViewer.getDocument().getFileData();
        case 2:
          data = _context33.sent;
          byteArray = new Uint8Array(data);
          blob = new Blob([byteArray]);
          (0, _fileSaver.saveAs)(blob, filename);
          return _context33.abrupt("return", true);
        case 7:
        case "end":
          return _context33.stop();
      }
    }, _callee19);
  }));
  return _downloadFileAs.apply(this, arguments);
}
function downloadFile(_x7, _x8) {
  return _downloadFile.apply(this, arguments);
}
function _downloadFile() {
  _downloadFile = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regeneratorRuntime().mark(function _callee20(ctx, file) {
    var downloadFileResponse, _context34, blob;
    return _regeneratorRuntime().wrap(function _callee20$(_context35) {
      while (1) switch (_context35.prev = _context35.next) {
        case 0:
          _context35.next = 2;
          return fetch(file.url, {
            method: 'GET',
            headers: {
              'Accept': file.type
            }
          });
        case 2:
          downloadFileResponse = _context35.sent;
          if (downloadFileResponse.ok) {
            _context35.next = 6;
            break;
          }
          (0, _emitEvents.emit)(ctx, 'error', (0, _concat.default)(_context34 = "Unable to download file ".concat(file.name, " from ")).call(_context34, file.url, "."));
          return _context35.abrupt("return", false);
        case 6:
          _context35.next = 8;
          return downloadFileResponse.blob();
        case 8:
          blob = _context35.sent;
          (0, _fileSaver.saveAs)(blob, getFilenameWithExtension(file.name, file.type));
          return _context35.abrupt("return", true);
        case 11:
        case "end":
          return _context35.stop();
      }
    }, _callee20);
  }));
  return _downloadFile.apply(this, arguments);
}
var FilePreviewPDFTron = /*#__PURE__*/function (_BlueElement) {
  (0, _inherits2.default)(FilePreviewPDFTron, _BlueElement);
  var _super = (0, _createSuper2.default)(FilePreviewPDFTron);
  function FilePreviewPDFTron() {
    var _context2;
    var _this;
    (0, _classCallCheck2.default)(this, FilePreviewPDFTron);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, (0, _concat.default)(_context2 = [this]).call(_context2, args));
    _this.file = undefined;
    _this.files = [];
    _this.language = 'en';
    _this.additionalHeaders = {};
    _this._saveOnFieldChange = false;
    _this.headerButtons = [{
      id: 'close',
      text: (0, _i18n.translate)('button.close'),
      click: _this.close,
      enabled: function enabled() {
        return true;
      }
    }];
    _this.overlayButtons = [{
      id: 'navigate-previous',
      text: (0, _i18n.translate)('preview.previousDocument'),
      icon: 'bento-icon-chevron-left',
      click: _this.loadPreviousFile,
      enabled: function enabled() {
        return _this.canLoadPreviousFile();
      },
      visible: function visible() {
        return _this.files.length > 1;
      }
    }, {
      id: 'navigate-next',
      text: (0, _i18n.translate)('preview.nextDocument'),
      icon: 'bento-icon-chevron-right',
      click: _this.loadNextFile,
      enabled: function enabled() {
        return _this.canLoadNextFile();
      },
      visible: function visible() {
        return _this.files.length > 1;
      }
    }];
    _this._viewerInstance = undefined;
    _this._initialized = undefined;
    _this.status = PreviewStatus.None;
    _this.viewerInstanceSet = false;
    _this.saveOnFieldChangeSet = false;
    _this.currentDocumentBlob = void 0;
    _this.currentUrl = '';
    _this.componentClasses = {
      active: false
    };
    return _this;
  }
  (0, _createClass2.default)(FilePreviewPDFTron, [{
    key: "viewerInstance",
    get: function get() {
      return this._viewerInstance;
    },
    set: function set(val) {
      this._viewerInstance = val;
      this.viewerInstanceSet = true;
      if (this.saveOnFieldChangeSet) {
        if (this._saveOnFieldChange) {
          this.saveChangeToServer();
        } else {
          this.lockFields();
        }
      }
    }
  }, {
    key: "saveOnFieldChange",
    get: function get() {
      return this._saveOnFieldChange;
    },
    set: function set(val) {
      this._saveOnFieldChange = val;
      this.saveOnFieldChangeSet = true;
      if (this.viewerInstanceSet) {
        if (this._saveOnFieldChange) {
          this.saveChangeToServer();
        } else {
          this.lockFields();
        }
      }
    }
  }, {
    key: "shouldUpdate",
    value: function shouldUpdate(_changedProperties) {
      return true;
    }
  }, {
    key: "firstUpdated",
    value: function () {
      var _firstUpdated = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(_changedProperties) {
        return _regeneratorRuntime().wrap(function _callee$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return this.initializeViewerInstance(this.shadowRoot.getElementById('pdftron'));
            case 2:
            case "end":
              return _context3.stop();
          }
        }, _callee, this);
      }));
      function firstUpdated(_x9) {
        return _firstUpdated.apply(this, arguments);
      }
      return firstUpdated;
    }()
  }, {
    key: "render",
    value: function render() {
      var _context4,
        _this2 = this;
      return this.html(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["<article class=", ">\n      ", "\n      ", "\n      ", "\n    </article>"])), (0, _element.classMap)(this.componentClasses), this.renderHeader(), this.renderViewer(), (0, _map.default)(_context4 = this.overlayButtons).call(_context4, function (button) {
        return _this2.renderOverlayButton(button);
      }));
    }
  }, {
    key: "initializeViewerInstance",
    value: function () {
      var _initializeViewerInstance = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5(element) {
        var _this3 = this;
        return _regeneratorRuntime().wrap(function _callee5$(_context11) {
          while (1) switch (_context11.prev = _context11.next) {
            case 0:
              if (!(this._initialized !== undefined)) {
                _context11.next = 2;
                break;
              }
              return _context11.abrupt("return", this._initialized);
            case 2:
              this._initialized = (0, _webviewer.default)({
                path: PDFTRON_PUBLIC_LIB,
                licenseKey: 'Thomson Reuters Tax and Accounting Inc :OEM:See Agreement::B+:AMS(20260426):ECB51A720457480A4360B13AC982537860614F8B5C707AB29DB51BD45CD5009E1A8A31F5C7'
              }, element).then(function (instance) {
                _this3.viewerInstance = instance;
                _this3.status = PreviewStatus.Ready;
                void instance.UI.setLanguage(_this3.language);
                instance.UI.setPrintQuality(5);
                var viewerStylesheet = instance.UI.iframeWindow.document.createElement('style');
                viewerStylesheet.innerText = FilePreviewPDFTron.viewerStyles.cssText;
                instance.UI.iframeWindow.document.body.append(viewerStylesheet);
                instance.UI.disableElements(['ribbons', 'contextMenuPopup', 'textPopup', 'annotationPopup', 'thumbnailsPanel', 'thumbnailsPanelButton']);
                instance.UI.setActiveLeftPanel('outlinesPanel');
                var dynamicElements = [{
                  elementName: 'pageNavOverlay',
                  enabled: function enabled() {
                    return instance.Core.documentViewer.getPageCount() > 1;
                  }
                }];
                instance.UI.disableElements((0, _map.default)(dynamicElements).call(dynamicElements, function (e) {
                  return e.elementName;
                }));
                instance.UI.setToolbarGroup('toolbarGroup-View', true);
                _this3.headerButtons.unshift({
                  id: 'preview-file-print',
                  icon: 'bento-icon-print',
                  text: (0, _i18n.translate)('button.print'),
                  click: function click() {
                    return instance.UI.print();
                  },
                  enabled: function enabled() {
                    return _this3.status === PreviewStatus.Loaded;
                  }
                });
                _this3.headerButtons.unshift({
                  id: 'preview-file-download',
                  icon: 'bento-icon-download',
                  text: (0, _i18n.translate)('button.download'),
                  click: function () {
                    var _click = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
                      return _regeneratorRuntime().wrap(function _callee2$(_context5) {
                        while (1) switch (_context5.prev = _context5.next) {
                          case 0:
                            return _context5.abrupt("return", download(_this3, instance, _this3.file));
                          case 1:
                          case "end":
                            return _context5.stop();
                        }
                      }, _callee2);
                    }));
                    function click() {
                      return _click.apply(this, arguments);
                    }
                    return click;
                  }(),
                  enabled: function enabled() {
                    var _context6;
                    return (0, _includes.default)(_context6 = [PreviewStatus.NotLoaded, PreviewStatus.Loaded]).call(_context6, _this3.status);
                  }
                });
                void _this3.requestUpdate('headerButtons');
                instance.Core.documentViewer.addEventListener('documentLoaded', /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
                  var _context7, _context8;
                  return _regeneratorRuntime().wrap(function _callee3$(_context9) {
                    while (1) switch (_context9.prev = _context9.next) {
                      case 0:
                        _this3.status = PreviewStatus.Loaded;
                        instance.UI.enableElements((0, _map.default)(_context7 = (0, _filter.default)(dynamicElements).call(dynamicElements, function (e) {
                          return e.enabled();
                        })).call(_context7, function (e) {
                          return e.elementName;
                        }));
                        instance.UI.disableElements((0, _map.default)(_context8 = (0, _filter.default)(dynamicElements).call(dynamicElements, function (e) {
                          return !e.enabled();
                        })).call(_context8, function (e) {
                          return e.elementName;
                        }));
                        instance.UI.setZoomLevel(1.2);
                      case 4:
                      case "end":
                        return _context9.stop();
                    }
                  }, _callee3);
                })));
                instance.Core.documentViewer.addEventListener('documentUnloaded', /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
                  return _regeneratorRuntime().wrap(function _callee4$(_context10) {
                    while (1) switch (_context10.prev = _context10.next) {
                      case 0:
                        _this3.status = PreviewStatus.Ready;
                        instance.UI.disableElements((0, _map.default)(dynamicElements).call(dynamicElements, function (e) {
                          return e.elementName;
                        }));
                      case 2:
                      case "end":
                        return _context10.stop();
                    }
                  }, _callee4);
                })));
                instance.UI.iframeWindow.addEventListener('loaderror', function () {
                  _this3.status = PreviewStatus.NotLoaded;
                  instance.UI.displayErrorMessage((0, _i18n.translate)('preview.notAvailable'));
                });
              });
              _context11.next = 5;
              return this._initialized;
            case 5:
            case "end":
              return _context11.stop();
          }
        }, _callee5, this);
      }));
      function initializeViewerInstance(_x10) {
        return _initializeViewerInstance.apply(this, arguments);
      }
      return initializeViewerInstance;
    }()
  }, {
    key: "getDocumentBlob",
    value: function () {
      var _getDocumentBlob = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6(docViewer) {
        var annotationManager, xfdfString, options, doc, data, arr, blob, file;
        return _regeneratorRuntime().wrap(function _callee6$(_context12) {
          while (1) switch (_context12.prev = _context12.next) {
            case 0:
              annotationManager = docViewer.getAnnotationManager();
              _context12.next = 3;
              return annotationManager.exportAnnotations({
                annotList: [],
                fields: true,
                widgets: true,
                links: true
              });
            case 3:
              xfdfString = _context12.sent;
              options = {
                xfdfString: xfdfString
              };
              doc = docViewer.getDocument();
              _context12.next = 8;
              return doc.getFileData(options);
            case 8:
              data = _context12.sent;
              arr = new Uint8Array(data);
              blob = new Blob([arr], {
                type: 'application/pdf'
              });
              file = new File([blob], doc.getFilename(), undefined);
              return _context12.abrupt("return", file);
            case 13:
            case "end":
              return _context12.stop();
          }
        }, _callee6);
      }));
      function getDocumentBlob(_x11) {
        return _getDocumentBlob.apply(this, arguments);
      }
      return getDocumentBlob;
    }()
  }, {
    key: "exportAnnotations",
    value: function () {
      var _exportAnnotations = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7(annotationManager, exportedAnnotations) {
        var annotations, _iterator, _step, annotation, image;
        return _regeneratorRuntime().wrap(function _callee7$(_context13) {
          while (1) switch (_context13.prev = _context13.next) {
            case 0:
              annotations = exportedAnnotations !== null && exportedAnnotations !== void 0 ? exportedAnnotations : annotationManager.getAnnotationsList();
              _iterator = (0, _createForOfIteratorHelper2.default)(annotations);
              try {
                for (_iterator.s(); !(_step = _iterator.n()).done;) {
                  annotation = _step.value;
                  image = annotation.image;
                  if (image) {
                    image.width = image.naturalWidth;
                    image.height = image.naturalHeight;
                  }
                }
              } catch (err) {
                _iterator.e(err);
              } finally {
                _iterator.f();
              }
              return _context13.abrupt("return", exportedAnnotations ? annotationManager.exportAnnotations({
                annotList: exportedAnnotations
              }) : annotationManager.exportAnnotations());
            case 4:
            case "end":
              return _context13.stop();
          }
        }, _callee7);
      }));
      function exportAnnotations(_x12, _x13) {
        return _exportAnnotations.apply(this, arguments);
      }
      return exportAnnotations;
    }()
  }, {
    key: "loadFile",
    value: function () {
      var _loadFile = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regeneratorRuntime().mark(function _callee8(file) {
        var convertToPDF, loadDocumentByBlob;
        return _regeneratorRuntime().wrap(function _callee8$(_context14) {
          while (1) switch (_context14.prev = _context14.next) {
            case 0:
              _context14.next = 2;
              return this._initialized;
            case 2:
              _context14.next = 4;
              return this.unloadFile();
            case 4:
              this.file = file;
              if (canBePreviewed(file.type)) {
                _context14.next = 9;
                break;
              }
              this.status = PreviewStatus.NotLoaded;
              this._viewerInstance.UI.displayErrorMessage((0, _i18n.translate)('preview.notAvailable'));
              return _context14.abrupt("return");
            case 9:
              this.status = PreviewStatus.Loading;
              convertToPDF = !canRenderOnClient(file.type) && canRenderOnServer(file.type);
              loadDocumentByBlob = this.currentDocumentBlob && this.currentUrl === file.url;
              this._viewerInstance.UI.loadDocument(loadDocumentByBlob ? this.currentDocumentBlob : file.url, {
                extension: convertToPDF ? PDF_EXTENSION : getFileExtensionFromType(file.type),
                filename: file.name,
                withCredentials: true,
                customHeaders: (0, _objectSpread2.default)({
                  accept: convertToPDF ? PDF_MIMETYPE : file.type
                }, this.additionalHeaders)
              });
            case 13:
            case "end":
              return _context14.stop();
          }
        }, _callee8, this);
      }));
      function loadFile(_x14) {
        return _loadFile.apply(this, arguments);
      }
      return loadFile;
    }()
  }, {
    key: "unloadFile",
    value: function () {
      var _unloadFile = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regeneratorRuntime().mark(function _callee9() {
        var _context15;
        var _this$_viewerInstance;
        return _regeneratorRuntime().wrap(function _callee9$(_context16) {
          while (1) switch (_context16.prev = _context16.next) {
            case 0:
              if (!(this._viewerInstance && (0, _includes.default)(_context15 = [PreviewStatus.NotLoaded, PreviewStatus.Loaded]).call(_context15, this.status))) {
                _context16.next = 3;
                break;
              }
              _context16.next = 3;
              return (_this$_viewerInstance = this._viewerInstance) === null || _this$_viewerInstance === void 0 ? void 0 : _this$_viewerInstance.UI.closeDocument();
            case 3:
              this.file = undefined;
              this.status = PreviewStatus.Ready;
            case 5:
            case "end":
              return _context16.stop();
          }
        }, _callee9, this);
      }));
      function unloadFile() {
        return _unloadFile.apply(this, arguments);
      }
      return unloadFile;
    }()
  }, {
    key: "loadPreviousFile",
    value: function () {
      var _loadPreviousFile = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regeneratorRuntime().mark(function _callee10() {
        var fileIndex;
        return _regeneratorRuntime().wrap(function _callee10$(_context17) {
          while (1) switch (_context17.prev = _context17.next) {
            case 0:
              fileIndex = this.currentFileIndex();
              if (!(fileIndex > 0)) {
                _context17.next = 7;
                break;
              }
              _context17.next = 4;
              return this.unloadFile();
            case 4:
              _context17.next = 6;
              return this.loadFile(this.files[fileIndex - 1]);
            case 6:
              (0, _emitEvents.emit)(this, 'documentNav', this.file);
            case 7:
            case "end":
              return _context17.stop();
          }
        }, _callee10, this);
      }));
      function loadPreviousFile() {
        return _loadPreviousFile.apply(this, arguments);
      }
      return loadPreviousFile;
    }()
  }, {
    key: "loadNextFile",
    value: function () {
      var _loadNextFile = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regeneratorRuntime().mark(function _callee11() {
        var fileIndex;
        return _regeneratorRuntime().wrap(function _callee11$(_context18) {
          while (1) switch (_context18.prev = _context18.next) {
            case 0:
              fileIndex = this.currentFileIndex();
              if (!(fileIndex >= 0 && fileIndex < this.files.length)) {
                _context18.next = 7;
                break;
              }
              _context18.next = 4;
              return this.unloadFile();
            case 4:
              _context18.next = 6;
              return this.loadFile(this.files[fileIndex + 1]);
            case 6:
              (0, _emitEvents.emit)(this, 'documentNav', this.file);
            case 7:
            case "end":
              return _context18.stop();
          }
        }, _callee11, this);
      }));
      function loadNextFile() {
        return _loadNextFile.apply(this, arguments);
      }
      return loadNextFile;
    }()
  }, {
    key: "canLoadPreviousFile",
    value: function canLoadPreviousFile() {
      var _context19;
      return this.isFileInRange({
        min: 1
      }) && (0, _includes.default)(_context19 = [PreviewStatus.NotLoaded, PreviewStatus.Loaded]).call(_context19, this.status);
    }
  }, {
    key: "canLoadNextFile",
    value: function canLoadNextFile() {
      var _context20;
      return this.isFileInRange({
        max: this.files.length - 2
      }) && (0, _includes.default)(_context20 = [PreviewStatus.NotLoaded, PreviewStatus.Loaded]).call(_context20, this.status);
    }
  }, {
    key: "currentFileIndex",
    value: function currentFileIndex() {
      var _this4 = this;
      if (Boolean(this.file) && this.files.length > 1) {
        var _context21;
        return (0, _findIndex.default)(_context21 = this.files).call(_context21, function (f) {
          return f.id === _this4.file.id;
        });
      }
      return -1;
    }
  }, {
    key: "isFileInRange",
    value: function isFileInRange(range) {
      var fileIndex = this.currentFileIndex();
      return (isNaN(range.min) || fileIndex >= (range.min || 0)) && (isNaN(range.max) || fileIndex <= range.max);
    }
  }, {
    key: "close",
    value: function () {
      var _close = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regeneratorRuntime().mark(function _callee12() {
        return _regeneratorRuntime().wrap(function _callee12$(_context22) {
          while (1) switch (_context22.prev = _context22.next) {
            case 0:
              _context22.next = 2;
              return this.unloadFile();
            case 2:
              this.componentClasses.active = false;
              _context22.next = 5;
              return this.requestUpdate();
            case 5:
              (0, _emitEvents.emit)(this, 'closePreview', true);
              this._viewerInstance.Core.annotationManager.removeEventListener();
            case 7:
            case "end":
              return _context22.stop();
          }
        }, _callee12, this);
      }));
      function close() {
        return _close.apply(this, arguments);
      }
      return close;
    }()
  }, {
    key: "open",
    value: function () {
      var _open = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regeneratorRuntime().mark(function _callee13(file) {
        return _regeneratorRuntime().wrap(function _callee13$(_context23) {
          while (1) switch (_context23.prev = _context23.next) {
            case 0:
              this.componentClasses.active = true;
              _context23.next = 3;
              return this.requestUpdate();
            case 3:
              _context23.next = 5;
              return this.loadFile(file);
            case 5:
            case "end":
              return _context23.stop();
          }
        }, _callee13, this);
      }));
      function open(_x15) {
        return _open.apply(this, arguments);
      }
      return open;
    }()
  }, {
    key: "navigateTo",
    value: function () {
      var _navigateTo = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regeneratorRuntime().mark(function _callee14(id) {
        var _context24;
        var navigateToFile;
        return _regeneratorRuntime().wrap(function _callee14$(_context25) {
          while (1) switch (_context25.prev = _context25.next) {
            case 0:
              navigateToFile = (0, _find.default)(_context24 = this.files).call(_context24, function (f) {
                return f.id === id;
              });
              if (navigateToFile) {
                void this.open(navigateToFile);
              }
            case 2:
            case "end":
              return _context25.stop();
          }
        }, _callee14, this);
      }));
      function navigateTo(_x16) {
        return _navigateTo.apply(this, arguments);
      }
      return navigateTo;
    }()
  }, {
    key: "renderHeader",
    value: function renderHeader() {
      var _this$file,
        _context26,
        _this5 = this;
      return this.html(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2.default)(["<header>\n        <summary>", "</summary>\n        <nav>", "</nav>\n      </header>"])), (_this$file = this.file) === null || _this$file === void 0 ? void 0 : _this$file.name, (0, _map.default)(_context26 = this.headerButtons).call(_context26, function (button) {
        return button.icon ? _this5.renderHeaderIconButton(button) : _this5.renderHeaderButton(button);
      }));
    }
  }, {
    key: "renderHeaderButton",
    value: function renderHeaderButton(button) {
      return this.html(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2.default)(["<li><button id=\"", "\" data-qe-id=\"", "\" @click=\"", "\">", "</button></li>"])), button.id, button.id, button.click, button.text);
    }
  }, {
    key: "renderHeaderIconButton",
    value: function renderHeaderIconButton(button) {
      return this.html(_templateObject4 || (_templateObject4 = (0, _taggedTemplateLiteral2.default)(["<li><button class=\"icon\" title=\"", "\" id=\"", "\" data-qe-id=\"", "\" @click=\"", "\" .disabled=\"", "\"><span class=\"", "\"></span></button></li>"])), button.text, button.id, button.id, button.click, !button.enabled(), button.icon);
    }
  }, {
    key: "renderViewer",
    value: function renderViewer() {
      return this.html(_templateObject5 || (_templateObject5 = (0, _taggedTemplateLiteral2.default)(["<main><div id=\"pdftron\"></div></main>"])));
    }
  }, {
    key: "renderOverlayButton",
    value: function renderOverlayButton(button) {
      return !button.visible || button.visible() ? this.html(_templateObject6 || (_templateObject6 = (0, _taggedTemplateLiteral2.default)(["<button class=\"overlay\" id=\"", "\" data-qe-id=\"", "\" title=\"", "\" @click=", " .disabled=\"", "\"><span class=\"", "\"></span></button>"])), button.id, button.id, button.text, button.click, !button.enabled(), button.icon) : null;
    }
  }, {
    key: "saveChangeToServer",
    value: function saveChangeToServer() {
      var _this6 = this;
      var debounceSendRequest;
      if (this.saveOnFieldChange) {
        this._viewerInstance.Core.annotationManager.addEventListener('fieldChanged', /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regeneratorRuntime().mark(function _callee15() {
          var _context27, _this6$file, _this6$file2;
          var serializeAnnotations, parts, annotationFile, documentBlob, initiatorId, formData, url, _context28;
          return _regeneratorRuntime().wrap(function _callee15$(_context29) {
            while (1) switch (_context29.prev = _context29.next) {
              case 0:
                _context29.next = 2;
                return _this6.exportAnnotations(_this6._viewerInstance.Core.annotationManager, []);
              case 2:
                serializeAnnotations = _context29.sent;
                parts = [new Blob([serializeAnnotations], {
                  type: 'text/plain'
                })];
                annotationFile = new File(parts, 'metaData.xfdf');
                _context29.next = 7;
                return _this6.getDocumentBlob(_this6._viewerInstance.Core.documentViewer);
              case 7:
                documentBlob = _context29.sent;
                _this6.currentDocumentBlob = documentBlob;
                initiatorId = 'dms-socket-client-' + (0, _slice.default)(_context27 = Math.random().toString()).call(_context27, 2);
                formData = new FormData();
                formData.append('file[]', documentBlob);
                if (annotationFile) {
                  formData.append('annotations[]', annotationFile);
                }
                _this6.currentUrl = (_this6$file = _this6.file) === null || _this6$file === void 0 ? void 0 : _this6$file.url;
                url = ((_this6$file2 = _this6.file) === null || _this6$file2 === void 0 ? void 0 : _this6$file2.url) + "?initiator=".concat(initiatorId);
                _this6.putRequestUrl = url;
                _this6.putRequestContent = formData;
                if (!debounceSendRequest) {
                  debounceSendRequest = _this6.debounce((0, _bind.default)(_context28 = _this6.sendRequest).call(_context28, _this6));
                }
                debounceSendRequest();
              case 19:
              case "end":
                return _context29.stop();
            }
          }, _callee15);
        })));
      }
    }
  }, {
    key: "debounce",
    value: function debounce(func) {
      var _arguments = arguments,
        _this7 = this;
      var timeout = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2000;
      var debounceTimer;
      return function () {
        var args = _arguments;
        clearTimeout(debounceTimer);
        debounceTimer = (0, _setTimeout2.default)(function () {
          return func.apply(_this7, args);
        }, timeout);
      };
    }
  }, {
    key: "sendRequest",
    value: function sendRequest() {
      var xhr = new XMLHttpRequest();
      xhr.open('PUT', this.putRequestUrl, true);
      xhr.send(this.putRequestContent);
    }
  }, {
    key: "lockFields",
    value: function lockFields() {
      var _this8 = this;
      this._viewerInstance.Core.documentViewer.addEventListener('pageComplete', /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regeneratorRuntime().mark(function _callee16() {
        return _regeneratorRuntime().wrap(function _callee16$(_context30) {
          while (1) switch (_context30.prev = _context30.next) {
            case 0:
              _this8._viewerInstance.Core.annotationManager.getFieldManager().forEachField(function (field) {
                (0, _flags.default)(field).set('ReadOnly', true);
              });
            case 1:
            case "end":
              return _context30.stop();
          }
        }, _callee16);
      })));
    }
  }], [{
    key: "is",
    get: function get() {
      return 'file-preview-pdftron';
    }
  }, {
    key: "properties",
    get: function get() {
      return {
        file: {
          type: Object,
          attribute: true,
          reflect: false
        },
        files: {
          type: Array,
          attribute: true,
          reflect: false
        },
        headerButtons: {
          type: Array,
          attribute: false,
          reflect: false
        },
        status: {
          type: String,
          attribute: false,
          reflect: false
        },
        language: {
          type: String,
          attribute: true,
          reflect: false
        },
        additionalHeaders: {
          type: Object,
          attribute: false,
          reflect: false
        }
      };
    }
  }, {
    key: "styles",
    get: function get() {
      return (0, _element.css)(_templateObject7 || (_templateObject7 = (0, _taggedTemplateLiteral2.default)(["\n    ", "\n    :host article {\n      visibility: hidden;\n      height: 0px;\n      width: 0px;\n    }\n    :host article.active {\n      visibility: visible;\n      position: fixed;\n      top: 0; left: 0; right: 0; bottom: 0;\n      width: 100%;\n      height: 100%;\n      background-color: rgba(0, 0, 0, 0.7);\n      z-index: 2000;\n    }\n    :host article header {\n      background-color: #212121;\n      color: #ffffff;\n      height: 50px;\n      display: flex;\n      justify-content: space-between;\n    }\n    :host article header summary {\n      font-size: 18px;\n      overflow: hidden;\n      text-overflow: ellipsis;\n      white-space: nowrap;\n      line-height: 50px;\n      margin-left: 10px;\n    }\n    :host article header nav {\n      display: flex;\n    }\n    :host article header nav li {\n      list-style: none;\n      line-height: 46px;\n    }\n    /* Text buttons */\n    :host article header nav li button:not(.icon) {\n      min-width: 50px;\n      margin: 3px;\n      margin: 3px 10px 3px 10px;\n      height: 34px;\n      min-width: 90px;\n      padding-left: 10px;\n      padding-right: 10px;\n      border: 2px solid #ddd;\n      border-radius: 5px;\n      background-color: #eee;\n      color: #444;\n      text-transform: uppercase;\n      letter-spacing: 1px !important;\n      font-size: 12px;\n      font-family: KnowledgeMedium, Arial;\n    }\n    :host article header nav li button:not(.icon):hover {\n      background-color: #fff;\n      cursor: pointer;\n    }\n    /* Icon buttons */\n    :host article header nav li button.icon {\n      width: 38px;\n      margin: 6px 10px 3px 3px;\n      height: 40px;\n      border: 2px;\n      border-radius: 10px;\n      background-color: transparent;\n      color: #eee;\n      font-size: 20px;\n    }\n    :host article header nav li button.icon:not(:disabled):hover {\n      background-color: rgba(255, 255, 255, 0.2);\n      cursor: pointer;\n    }\n    :host article header nav li button.icon:disabled {\n      opacity: 0.3;\n      cursor: default;\n    }\n    :host article header nav li button#close {\n      margin-left: 20px;\n    }\n    /* PDFTron WebViewer component host */\n    :host article main {\n      height: calc(100vh - 50px);\n    }\n    :host article main div {\n      height: 100%;\n    }\n    :host button.overlay {\n      position: fixed;\n      height: 40px;\n      width: 40px;\n      background-color: #212121;\n      border-radius: 20px;\n      border: 1px solid #212121;\n      color: #ffffff;\n      opacity: 0.7;\n      z-index: 9999;\n    }\n    :host button.overlay:disabled {\n      opacity: 0.3;\n    }\n    :host button.overlay:disabled:hover {\n      cursor: not-allowed;\n    }\n    :host button.overlay:hover:not(:disabled) {\n      background-color: #5f5f5f;\n      border-color: #5f5f5f;\n      opacity: 0.9;\n      cursor: pointer;\n    }\n    :host button.overlay#navigate-previous {\n      top: calc(50% + 22px);\n      left: 24px;\n    }\n    :host button.overlay#navigate-next {\n      top: calc(50% + 22px);\n      right: 24px;\n    }\n    "])), _bentoFonts.bentoFonts);
    }
  }, {
    key: "viewerStyles",
    get: function get() {
      return (0, _element.css)(_templateObject8 || (_templateObject8 = (0, _taggedTemplateLiteral2.default)(["\n      .PrintModal .ui__choice--radio,\n      .PrintModal .col,\n      .PrintModal .apply-watermark {\n        display: none !important;\n      }\n      @media print {\n        .PrintHandler {\n          top: 0 !important;\n          bottom: 0 !important;\n          left: 0 !important;\n          right: 0 !important;\n          position: absolute !important;\n        }\n        .PrintHandler #print-handler {\n          width: auto !important;\n        }\n      }\n    "])));
    }
  }]);
  return FilePreviewPDFTron;
}(_element.BlueElement);
exports.FilePreviewPDFTron = FilePreviewPDFTron;
var registerFilePreviewPDFTron = function registerFilePreviewPDFTron(config) {
  (0, _element.register)(FilePreviewPDFTron);
  if (config !== null && config !== void 0 && config.webviewerUrl) {
    PDFTRON_PUBLIC_LIB = config.webviewerUrl;
  }
};
exports.registerFilePreviewPDFTron = registerFilePreviewPDFTron;
function openPreviewPDFTron(_x17, _x18) {
  return _openPreviewPDFTron.apply(this, arguments);
}
function _openPreviewPDFTron() {
  _openPreviewPDFTron = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regeneratorRuntime().mark(function _callee21(file, config) {
    var closePreview;
    return _regeneratorRuntime().wrap(function _callee21$(_context36) {
      while (1) switch (_context36.prev = _context36.next) {
        case 0:
          if (!PREVIEW_INSTANCE) {
            PREVIEW_INSTANCE = document.createElement('file-preview-pdftron');
            document.body.appendChild(PREVIEW_INSTANCE);
          }
          _context36.next = 3;
          return getWebViewerLanguage(config === null || config === void 0 ? void 0 : config.language);
        case 3:
          PREVIEW_INSTANCE.language = _context36.sent;
          PREVIEW_INSTANCE.additionalHeaders = {
            authorization: "UDSLongToken ".concat((config === null || config === void 0 ? void 0 : config.udsToken) || _session.store.uds())
          };
          PREVIEW_INSTANCE.saveOnFieldChange = file.saveOnFieldChange;
          PREVIEW_INSTANCE.files = (config === null || config === void 0 ? void 0 : config.files) || [];
          closePreview = function closePreview() {
            if (config !== null && config !== void 0 && config.onClose) {
              config.onClose(PREVIEW_INSTANCE);
            }
            PREVIEW_INSTANCE.removeEventListener('closePreview', closePreview);
          };
          PREVIEW_INSTANCE.addEventListener('closePreview', closePreview);
          _context36.next = 11;
          return PREVIEW_INSTANCE.open(file);
        case 11:
          return _context36.abrupt("return", PREVIEW_INSTANCE);
        case 12:
        case "end":
          return _context36.stop();
      }
    }, _callee21);
  }));
  return _openPreviewPDFTron.apply(this, arguments);
}
